import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CloseIcon } from "@/assets/icons/close.svg";

const AddFileByUrlModalRender = ({ visible, url, onCancel }) => {
  const { t } = useTranslation(["upload", "common"]);
  return visible ? (
    <div className="uploadingModal">
      <span className="timeIcon"></span>
      <div className="msg">
        <p style={{ fontSize: "16px" }}>
          {t("Analyzing")} {url}
        </p>
        <div className="close" onClick={onCancel} style={{ fontSize: "16px" }}>
          <CloseIcon /> {t("common:Cancel")}
        </div>
      </div>
    </div>
  ) : null;
};

export default AddFileByUrlModalRender;
